import axios from 'axios'
import util from './util'

var qs = {
    stringify: function (mapData) {
        var str = '';
        for (var name in mapData) {
            var temp = name + '=' + encodeURIComponent(mapData[name]) + '&';
            str += temp;
        }
        return str.slice(0, -1);
    }
};
var _self = {};
_self.BASE_URL = process.env.BASE_URL;
_self.AUTH_URL = process.env.AUTH_URL;
_self.FILE_URL = process.env.FILE_URL;
_self.HEADER = {
    appid: "LeonPC",
    device_id: "Leon",
    command: '',
    version: '1.0',
    token: '',
    sign: '',
    encrypt_type: 0
};
/**
 * 后端发送请求
 * command: 请求命令，
 * params: 请求参数，参数格式json
 * version:请求接口版本，默认为1.0，如无特殊请求，可不用上传此参数,
 * errorShow: 是否显示提示信息。默认是，当此参数不为undefined，不提示，调用者自己操作
 * **/
_self.send = function (_options) {
    return new Promise((resolve, reject) => {
        let companyNo = util.get('companyNo');
        _self.HEADER.token = util.get(companyNo + '_token');
        _self.HEADER.command = _options.command;
        if (typeof _options.version !== 'undefined') {
            _self.HEADER.version = _options.version;
        }
        let requestData = {
            head: JSON.stringify(_self.HEADER),
            body: JSON.stringify(_options.params)
        };
        let _path = _self.BASE_URL + _options.command + '/' + _self.HEADER.version;
        return axios({
            method: 'post',
            responseType: 'json',
            url: _path,
            data: qs.stringify(requestData),
            timeout: 30000
        }).then(function (res) {
            if (res.data.result_code == 0) {
                try {
                    if (res.data.body) {
                        res.data.body = JSON.parse(res.data.body);
                    }
                } catch (e) {
                }
                resolve(res);
            } else if (res.data.result_code == 5007) {
                util.cookieClear();
                let href = window.location.protocol+"//"+window.location.host+window.location.pathname;
                window.location.href=href+"/#/login?companyNo="+companyNo;
            } else {
                if (res.data.result_code != 5006 && res.data.result_code != 1006 && res.data.result_code != 1009) {
                    alert(res.data.message);
                }
                var err = new Error();
                err.data = res.data;
                reject(err);
            }
        }, function (error) {
            alert("请求出现错误：" + error);
            //封装成res一样格式的json
            var err = new Error(error);
            reject(err);
        });
    })
};

_self.sendNormal = function (_options) {
    let companyNo = util.get('companyNo');
    _self.HEADER.token = util.get(companyNo + '_token');
    _self.HEADER.command = _options.command;
    if (typeof _options.version !== 'undefined') {
        _self.HEADER.version = _options.version;
    }
    let requestData = {
        head: JSON.stringify(_self.HEADER),
        body: JSON.stringify(_options.params)
    };
    let _path = _self.BASE_URL + _options.command + '/' + _self.HEADER.version;
    return axios({
        method: 'post',
        responseType: 'json',
        url: _path,
        data: qs.stringify(requestData),
        timeout: 30000
    }).then(function (res) {
        if (res.data.result_code == 0) {
            try {
                if (res.data.body) {
                    res.data.body = JSON.parse(res.data.body);
                }
                return res;
            } catch (e) {
                return res;
            }
        } else {
            if (res.data.result_code == 5007) {// 重新请求
                util.cookieClear();
                let href = window.location.protocol+"//"+window.location.host+window.location.pathname;
                window.location.href=href+"/#/login?companyNo="+companyNo;
            } else if (res.data.result_code != 5006 && res.data.result_code != 1006 && res.data.result_code != 1009) {
                alert(res.data.message);
            }
            var err = new Error();
            err.data = res.data;
            return err;
        }
        //  return res;
    }, function (error) {
        alert("请求出现错误：" + error);
        //封装成res一样格式的json
        var err = new Error(error);
        throw err;
    });
};
export default _self;



// WEBPACK FOOTER //
// ./src/utils/http.js